module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "profile-layout"
    }
  }, [_c('profile-page')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ad52d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/ProfileLayout.vue
// module id = 398
// module chunks = 1